var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#FE572A",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.7714 37.0898C57.7714 35.6459 57.5176 31.5451 55.6282 27.8833C54.6984 26.0814 53.3993 24.4387 51.5855 23.2429C49.7851 22.0563 47.3579 21.2294 44.0286 21.2294C37.3641 21.2294 33.8128 24.0199 31.8177 27.2349C29.7288 30.6011 29.2286 34.6494 29.2286 37.0898C29.2286 41.7029 31.8121 47.0646 35.3422 52.2955C37.9127 56.1043 40.8247 59.6238 43.2597 62.508C43.6592 62.9812 44.3884 62.9803 44.786 62.5054C47.1159 59.722 49.8085 56.4015 52.1595 52.7333C55.385 47.7003 57.7714 42.3015 57.7714 37.0898ZM62 37.0898C62 43.5087 59.1005 49.7413 55.7191 55.0173C52.3251 60.3129 48.2472 64.9375 45.6535 68.0505C44.8078 69.0651 43.2493 69.0651 42.4036 68.0505C39.817 64.9459 35.4823 60.0646 31.8363 54.6621C28.2308 49.3194 25 43.0502 25 37.0898C25 34.2433 25.5569 29.3041 28.2251 25.0045C30.9872 20.5537 35.8931 17 44.0286 17C48.0988 17 51.3543 18.0238 53.9145 19.7115C56.4608 21.3903 58.2017 23.6472 59.386 25.9421C61.725 30.4747 62 35.3616 62 37.0898Z",
    fill: "#FE572A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.75 37.5C47.75 35.1528 45.8472 33.25 43.5 33.25C41.1528 33.25 39.25 35.1528 39.25 37.5C39.25 39.8472 41.1528 41.75 43.5 41.75C45.8472 41.75 47.75 39.8472 47.75 37.5ZM52 37.5C52 42.1944 48.1944 46 43.5 46C38.8056 46 35 42.1944 35 37.5C35 32.8056 38.8056 29 43.5 29C48.1944 29 52 32.8056 52 37.5Z",
    fill: "#FE572A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.961e6f09fde389c7831ebf1a035f3f55.svg";
export { ForwardRef as ReactComponent };